import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

const _get = async (queryParamFilters, queryParam, setParams, setMetadata) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  setParams?.(params)

  // const response = await apiClientV2({
  //   method: 'GET',
  //   baseURL,
  //   url: '/transaction',
  //   params: params,
  // })

  // setMetadata?.(response?.data.metadata)

  // return response?.data

  // TODO: change to real implementation when integrating with API
  const dummyResponse = {
    metadata: {
      count: 1,
      page: 1,
      total_count: 1,
      total_page: 1,
    },
    data: {
      ids: [],
      paginated_result: [
        {
          number: 'INV-1234',
          status: {
            name: "Terbit",
            color: "#123123"
          },
          customer: {
            'name': 'PT Jokowi Dodo'
          },
          created_date: "2024-04-05",
          due_date: "2024-04-05",
          amount: 30000000,
        }
      ]
    }
  }
  setMetadata?.(dummyResponse.metadata)

  return dummyResponse
}

export const get = (queryParamFilters, setParams, setMetadata) => async (queryParam) =>
  await _get(queryParamFilters, queryParam, setParams, setMetadata)

export const store = async (data) => {

  const queryParams = !('branch_id' in data) ? '?is_validating=true' : ''

  var baseURLV2 = baseURL.replace(/\/v\d+$/, `/v2`)

  const response = await apiClientV2({
    baseURL: baseURLV2,
    method: 'POST',
    url: `delivery-order/external/invoice${queryParams}`,
    data
  })

  return response?.data
}
